// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"664":"files","934":"folders"}[chunkId] || chunkId) + "." + {"664":"21eb0bf7","740":"845dd132","840":"ebfd3dc3","934":"0b6664e5","969":"fd8ad148"}[chunkId] + ".css";
};